import { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import JobZImage from "../../../common/jobz-img";
import { useAuth } from "../../../../context/AuthContext";
import { jobService } from "../../../../services/job-service";
import { empRoute, employer, publicUser } from "../../../../globals/route-names";

function EmpCompanyProfilePage() {
    const { user } = useAuth();
    const [form, setForm] = useState({
        name: "",
        website: "",
        location: "",
        description: ""
    });
    const [message, setMessage] = useState("");
    const [loading, setLoading] = useState(true);
    const [submitting, setSubmitting] = useState(false);
    const [logoFile, setLogoFile] = useState(null);
    const [bannerFile, setBannerFile] = useState(null);
    const [logoUrl, setLogoUrl] = useState("");
    const [bannerUrl, setBannerUrl] = useState("");

    useEffect(() => {
        setLoading(true);
        jobService.employerCompany()
            .then((data) => {
                const company = data.company || {};
                setForm({
                    name: company.name || `${user?.name || "Employer"}'s Company`,
                    website: company.website || "",
                    location: company.location || "",
                    description: company.description || ""
                });
                setLogoUrl(company.logo_url || "");
                setBannerUrl(company.banner_url || "");
            })
            .catch((error) => setMessage(error.message))
            .finally(() => setLoading(false));
    }, [user]);

    const update = (event) => {
        setForm({ ...form, [event.target.name]: event.target.value });
    };

    const submit = async (event) => {
        event.preventDefault();
        setSubmitting(true);
        setMessage("");
        try {
            const data = await jobService.saveEmployerCompany(form);
            let company = data.company || {};
            if (logoFile) {
                const logoData = await jobService.uploadCompanyLogo(logoFile);
                company = logoData.company || company;
                setLogoFile(null);
            }
            if (bannerFile) {
                const bannerData = await jobService.uploadCompanyBanner(bannerFile);
                company = bannerData.company || company;
                setBannerFile(null);
            }
            setForm({
                name: company.name || form.name,
                website: company.website || "",
                location: company.location || "",
                description: company.description || ""
            });
            setLogoUrl(company.logo_url || "");
            setBannerUrl(company.banner_url || "");
            setMessage("Company profile saved.");
        } catch (error) {
            setMessage(error.message);
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <>
            <div className="wt-admin-right-page-header clearfix">
                <h2>Company Profile</h2>
                <div className="breadcrumbs"><NavLink to={publicUser.HOME1}>Home</NavLink><NavLink to={empRoute(employer.DASHBOARD)}>Dashboard</NavLink><span>Company Profile</span></div>
            </div>
            <div className="panel panel-default">
                <div className="panel-heading wt-panel-heading p-a20">
                    <h4 className="panel-tittle m-a0">Logo and Cover image</h4>
                </div>
                <div className="panel-body wt-panel-body p-a20 p-b0 m-b30">
                    <div className="dashboard-profile-pic">
                        <div className="dashboard-profile-photo">
                            <JobZImage src={logoUrl || "images/jobs-company/pic1.jpg"} alt={form.name || "Company"} />
                        </div>
                        <div className="form-group m-t20">
                            <label>Company Logo</label>
                            <input className="form-control" type="file" accept="image/*" onChange={(event) => setLogoFile(event.target.files?.[0] || null)} />
                        </div>
                        <div className="form-group">
                            <label>Company Cover/Banner Image</label>
                            <input className="form-control" type="file" accept="image/*" onChange={(event) => setBannerFile(event.target.files?.[0] || null)} />
                        </div>
                        {bannerUrl && (
                            <div className="m-t20">
                                <JobZImage src={bannerUrl} alt={`${form.name || "Company"} banner`} />
                            </div>
                        )}
                    </div>
                </div>
            </div>
            <div className="panel panel-default">
                <div className="panel-heading wt-panel-heading p-a20">
                    <h4 className="panel-tittle m-a0">Basic Information</h4>
                </div>
                <div className="panel-body wt-panel-body p-a20 m-b30">
                    {message && <div className="alert alert-info">{message}</div>}
                    {loading ? (
                        <div className="p-a30 text-center">Loading company profile...</div>
                    ) : (
                        <form onSubmit={submit}>
                            <div className="row">
                                <Field label="Company Name" name="name" value={form.name} onChange={update} required icon="fa fa-building" />
                                <Field label="Website" name="website" value={form.website} onChange={update} icon="fa fa-globe-americas" placeholder="https://..." />
                                <Field label="Location" name="location" value={form.location} onChange={update} icon="fa fa-map-marker-alt" placeholder="City, Country" />
                                <div className="col-md-12">
                                    <div className="form-group">
                                        <label>Description</label>
                                        <textarea className="form-control" name="description" rows={5} placeholder="Tell candidates about your company." value={form.description} onChange={update} />
                                    </div>
                                </div>
                                <div className="col-lg-12 col-md-12">
                                    <div className="text-left">
                                        <button type="submit" className="site-button" disabled={submitting}>{submitting ? "Saving..." : "Save Changes"}</button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    )}
                </div>
            </div>
        </>
    )
}

function Field({ label, name, value, onChange, icon, required = false, placeholder = "" }) {
    return (
        <div className="col-xl-4 col-lg-12 col-md-12">
            <div className="form-group">
                <label>{label}</label>
                <div className="ls-inputicon-box">
                    <input className="form-control" name={name} type="text" required={required} placeholder={placeholder || label} value={value} onChange={onChange} />
                    <i className={`fs-input-icon ${icon}`} />
                </div>
            </div>
        </div>
    );
}

export default EmpCompanyProfilePage;
